<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2734 6.55859C15.7305 6.13672 15.7305 5.39844 15.2734 4.97656C14.8516 4.51953 14.1133 4.51953 13.6914 4.97656L10 8.66797L6.27344 4.97656C5.85156 4.51953 5.11328 4.51953 4.69141 4.97656C4.23438 5.39844 4.23438 6.13672 4.69141 6.55859L8.38281 10.25L4.69141 13.9766C4.23438 14.3984 4.23438 15.1367 4.69141 15.5586C5.11328 16.0156 5.85156 16.0156 6.27344 15.5586L10 11.8672L13.6914 15.5586C14.1133 16.0156 14.8516 16.0156 15.2734 15.5586C15.7305 15.1367 15.7305 14.3984 15.2734 13.9766L11.582 10.25L15.2734 6.55859Z"
      fill="currentColor"
    />
  </svg>
</template>
